import React from 'react'
import NewsApp from '../../features/news/News'
export default function News() {
  return (<NewsApp/> )
}
